
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from "react";
import ReactCountdownClock from "react-countdown-clock";
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Config from "../../../config/conf";
import { RESET_UI_BY_IDLE_TIMER } from "../../../actions/actionTypes";

class CountDownComponent extends Component {
    constructor (props) {
        super(props);
        this.hidePopup = this.hidePopup.bind(this);
    }
    hidePopup () {
        if (this.props.sendEventToBack) {
            this.props.dispatch({type: RESET_UI_BY_IDLE_TIMER });
        }
        this.props.closePopup()();
    }
    render () {
        return <ReactCountdownClock seconds={this.props.second}
                                    color={Config.colorForTimer}
                                    size={this.props.size || 60}
                                    onComplete={this.props.onComplete || this.hidePopup}/>;
    }
}

CountDownComponent.propTypes = {
    sendEventToBack: PropTypes.bool,
    closePopup: PropTypes.func,
    second: PropTypes.number,
    size: PropTypes.number,
    onComplete: PropTypes.any
};

CountDownComponent.defaultProps = {
    sendEventToBack: false
};

export default connect()(UIMixin({Component: CountDownComponent}));